export default [
  { title: 'Pfäffikon', value: '133219205FE', address: 'H1 Zahnärzte AG\nZentrum Staldenbach 2\n8808 Pfäffikon' }
]
